export default __webpack_public_path__ + "static/media/triangles_background.f6324afd.svg";